import { useCustomThemeDraftDispatch } from '@olo-web/client-state';
import { useCallback } from 'react';
import pSBC from 'shade-blend-color';
import { hex } from 'wcag-contrast';

const keyShadeMap = {
  50: -0.35,
  100: 0,
  200: 0.25,
  300: 0.5,
  400: 0.7,
  500: 0.8,
  600: 0.9,
};

const isColorAccessibleForSmallText = (color: string): boolean => {
  return hex(color, '#fff') >= 4.5;
};

const createColorThatIsAccessibleForSmallText = (color: string): string => {
  let ratio = hex(color, '#fff');
  while (ratio < 4.5) {
    color = pSBC(-0.01, color);
    ratio = hex(color, '#fff');
  }
  return color;
};

export const useGenerateShades = () => {
  const themeDispatch = useCustomThemeDraftDispatch();

  const generateShades = useCallback(
    ({ variant, key, value }: ICustomThemeColorPayload): void => {
      const colors = {};

      Object.keys(keyShadeMap).forEach((k) => {
        if (k === key) colors[key] = value;
        const shade = keyShadeMap[key] - keyShadeMap[k];
        colors[k] = pSBC(shade, value);
      });

      if (!isColorAccessibleForSmallText(colors[300])) {
        colors[350] = createColorThatIsAccessibleForSmallText(colors[300]);
        // If color is accessible for small text, use primary color.
      } else {
        colors[350] = colors[300];
      }

      themeDispatch({
        type: 'UPDATE_COLORS',
        payload: {
          variant,
          value: colors,
        },
      });
    },
    [themeDispatch]
  );

  return { generateShades };
};
